import { render, staticRenderFns } from "./Booklets.vue?vue&type=template&id=835b9e3e&"
import script from "./Booklets.vue?vue&type=script&lang=ts&"
export * from "./Booklets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports